module.exports = __webpack_public_path__ + "static/img/logo2.c3c924b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/logo2.png
// module id = wf6d
// module chunks = 2